import { Injectable, ApplicationRef, Inject, Optional } from '@angular/core';
import { ApiAppConfig } from '../api/model/AppConfig';
import { environment } from '@tytapp/environment';

@Injectable() 
export class AppConfig {
    constructor(
        private appRef : ApplicationRef
    ) {
        this._appStatusReady = new Promise((resolve, reject) => this._fireAppStatusReady = resolve);

        this._environment = environment ? environment.name : null;
        this._environment = this._environment || 'development';

        this.configure();
    }

    private _appStatus : ApiAppConfig;
    private _environment : string;

    public get appStatus() {
        return this._appStatus;
    }

    public get appStatusReady() {
        return this._appStatusReady;
    }
    
    public set appStatus(value) {
        this._appStatus = value;
    }

    private _fireAppStatusReady : Function;
    private _appStatusReady : Promise<void>;

    public async featureEnabled(feature : string): Promise<boolean> {
        await this.appStatusReady;

        if (!this._appStatus)
            return false;

        return this._appStatus.features.indexOf(feature) >= 0;
    }

    public fireAppStatusReady() {
        this._fireAppStatusReady();
    }

    public get environment() {
        return this._environment;
    }

    configure() {

        let environment = this.environment;

        //environment = 'production';

        if (environment == 'staging') { 
            this._rootUrl = 'https://app.staging.tyt.com';
            this._platformUrl = 'https://platform.staging.tyt.com';
            this._cableUrl = 'https://platform.staging.tyt.com/cable';
            this._apiUrl = 'https://platform.staging.tyt.com/api/v1';
            this._adminUrl = 'https://platform.staging.tyt.com';
            this._stripePublishableKey = 'pk_adWnCOMJxEWmPRRrETjFe4FAI02CX';
            this._accountsUrl = 'https://accounts.staging.tyt.com';
            this._forumsUrl = 'https://discuss.staging.tyt.com/';
            this._appUrl = 'https://app.staging.tyt.com';
            this._cookieDomain = '.staging.tyt.com';
            this._cookieName = 'tytauth_staging';
            this._userCookieName = 'tyt_user_uuid_staging';
            this._googleCastAppId = 'FF99FB52';
            this._purchaseUrl = `${this.accountsUrl}/join`;
        } else if (environment == 'production') {
            this._rootUrl = 'https://tyt.com';
            this._platformUrl = 'https://platform.tyt.com';
            this._cableUrl = 'https://platform.tyt.com/cable';
            this._apiUrl = 'https://platform.tyt.com/api/v1';
            this._adminUrl = 'https://platform.tyt.com';
            this._stripePublishableKey = 'pk_0zIUNvWdQMQTgAAOcX1k9p5BOUXTz';
            this._accountsUrl = 'https://accounts.tyt.com';
            this._forumsUrl = 'https://discuss.tyt.com/';
            this._appUrl = 'https://tyt.com';
            this._cookieDomain = '.tyt.com';
            this._cookieName = 'tytauth';
            this._userCookieName = 'tyt_user_uuid';
            this._googleCastAppId = 'F30612C0';

            //this._purchaseUrl = `${this.accountsUrl}/join/eec3a06`; // "site-nav" offer set for tracking
            //this._purchaseUrl = `https://join.tyt.com/join`; // for classic vs modern H2H test, October 6, 2020
            this._purchaseUrl = `${this.accountsUrl}/join`; // default offer set
        } else {
            let devHost = 'localhost';
            let http = 'http:';

            if (typeof window !== 'undefined') {

                if (!window.location.host.includes('ngrok')) {
                    http = window.location.protocol;
                    devHost = window.location.host.replace(/:4200/, '').replace(/:8081/, '');
                }
            }

            this._rootUrl = `${http}//${devHost}:4200`;
            this._platformUrl = `${http}//${devHost}:3000`;
            this._cableUrl = `${http}//${devHost}:3000/cable`;
            this._apiUrl = `${http}//${devHost}:3000/api/v1`;
            this._adminUrl = `${http}//${devHost}:3000`;
            this._accountsUrl = `${http}//${devHost}:4201`;
            this._forumsUrl = 'https://discuss.staging.tyt.com/';
            this._appUrl = `${http}//${devHost}:4200`;
            this._stripePublishableKey = 'pk_adWnCOMJxEWmPRRrETjFe4FAI02CX';
            this._cookieDomain = '';
            this._googleCastAppId = '1F95826C';
            this._purchaseUrl = `${this.accountsUrl}/join`;
        }

        //this._apiUrl = `https://platform.tyt.com/api/v1`; // DO-NOT-COMMIT
    }

    private _cookieDomain : string;
    private _cookieName : string = 'tytauth';
    private _userCookieName : string = 'tyt_user_uuid';
    private _rootUrl : string;
    private _platformUrl : string;
    private _accountsUrl : string;
    private _forumsUrl : string;
    private _appUrl : string;
    private _cableUrl : string;
    private _apiUrl : string;
    private _adminUrl : string;
    private _stripePublishableKey : string;
    private _googleCastAppId: string;
    private _purchaseUrl : string;

    public get stripePublishableKey() { return this._stripePublishableKey; }
    public get rootUrl() { return this._rootUrl; }
    public get platformUrl() { return this._platformUrl; }
    public get cableUrl() { return this._cableUrl; }

    /**
     * For example: platform.tyt.com/api/v1
     */
    public get apiUrl() { return this._apiUrl; }
    public get adminUrl() { return this._adminUrl; }
    public get accountsUrl() { return this._accountsUrl; }
    public get appUrl() { return this._appUrl; }
    public get cookieDomain() { return this._cookieDomain; }
    public get cookieName() { return this._cookieName; }
    public get userCookieName() { return this._userCookieName; }
    public get googleCastAppId() { return this._googleCastAppId }
    public get myAccountUrl() { return `${this.accountsUrl}/account`; }
    public get forumsUrl() { return this._forumsUrl; }
    public get purchaseUrl() { return this._purchaseUrl; }
    public get upgradeUrl() {
        return `${this.accountsUrl}/changeMembership`;
    }
}